import React, { Component } from 'react';
import { List, Card, Space } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/agents';
import { PlusSquareOutlined, EditOutlined } from '@ant-design/icons';

class AgentProduct extends Component {
    handleAdd = () => {
        this.props.onOpen();
    }
    handleUpdateAP = (agentProduct) => {
        this.props.onSetAP(agentProduct);
    }
    render() {
        let data = [];
        let agentProducts = this.props.agentProducts;
        for (let index in agentProducts) {
            let agentProduct = { key: agentProducts[index].productId, ...agentProducts[index] };
            data.push(agentProduct);
        }
        data.sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
        let list = null;
        if (data.length > 0) {
            list = <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 3,
                    lg:4,
                    xl:4,
                    xxl:4,
                }}
                style={{ marginTop: '24px' }}
                dataSource={data}
                renderItem={item => {
                    let productName=this.props.products.filter(product=>product.id===item.productId)[0].name;
                    let ap = { ...item }
                    let title = <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>AgentProduct:ID {item.id}</span><a onClick={() => this.handleUpdateAP(ap)}><EditOutlined style={{ fontSize: '20px' }} /></a></div>;
                    return (<List.Item>
                        <Card title={title}>
                            <span>Product :   <span style={{ fontSize: '16px', color: '#08c' }}>{productName}</span></span><br />
                            <span>Unit Price :  <span style={{ fontSize: '16px', color: '#08c' }}>{item.unitPrice}</span></span><br />
                            <span>Extra Commission :    <span style={{ fontSize: '16px', color: '#08c' }}>{item.extraCommission}</span></span><br />
                        </Card>
                    </List.Item>)
                }
                }
            />
        }
        return <>
            <Space size="middle" style={{ marginTop: "30px" }}>
                <a onClick={this.handleAdd}>
                    <PlusSquareOutlined style={{ fontSize: '36px', color: '#08c' }} />
                </a>
                <span style={{ fontSize: "18px" }}>Add agent product</span>
            </Space>
            { list}
        </>
    }
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        agentProducts: state.agents.agentDetail.agentProducts,
        products:state.products.products,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onOpen: () => dispatch(actions.openAgentProductAdd()),
        onSetAP: (agentProduct) => dispatch(actions.openAgentProductEdit(agentProduct)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentProduct);